<script setup>
import { ref, onMounted, watch, toRef ,reactive,onBeforeUnmount} from 'vue';
import { useCustomChart } from '@/composable/customChart.js'
import { getFontSize, numberFormatter, getThisYear } from '@/js/customChart.js'
import { useUserStore } from '@/store/user'
import { useUiStore } from '@/store/ui' // UI 스토어 임포트
import { useResizeObserver } from '@/composable/resizeObserver'
const uiStore = useUiStore();
const userStore = useUserStore()

const chartOptions = {
  padding: 10,
  gap: 10,
  columns: 12,
  rows: 16,
}
// const { canvasWrap, initCustomChart } = useCustomChart(drawChart, chartOptions, false ,'su',uiStore.isGlobalFullscreen)

import { getFCSTSummaryList } from '@/api/dashboard';

// props
const props = defineProps({
  gridArea: Object,
  employeeId: String,
  width: Number,
  height: Number,
  fiscalYear:String,
  title : String
})

// data
const fetchedData = ref()

// watch
watch([() => props.employeeId, ()=>props.fiscalYear], async (newValue) => {
  try {
    const [employeeId, fiscalYear] = newValue
    const result = await getFCSTSummaryList({
      fs_year: fiscalYear,
      employee_id: employeeId
    })
    fetchedData.value = result.rtn.at(0)
    initCustomChart()
  } catch (err) {
    console.error(err)
  }
})

watch( ()=>uiStore.isGlobalFullscreen, (newVal) =>{
  if(newVal){

  }
})
  const canvasWrap = ref(null)
  const canvasInfo = reactive({})
  const observer = ref()
  function initCanvas() {
    if (!canvasWrap.value) return
    const { width, height } = canvasWrap.value.getBoundingClientRect()
    const canvas = canvasWrap.value.children[0]
    
    // set canvas size
   
    canvas.style.height = `${height}px`
    canvas.width = width * 2
    canvas.style.width = `${width}px`
    canvas.height = height * 2
    if(uiStore.isGlobalFullscreen){
      canvas.width = width 
      canvas.height = height * 2
      canvas.style.width = `${width/1.5}px`
    }
    
    canvasInfo.padding = chartOptions.padding
    canvasInfo.contentWidth = canvas.width - ( canvasInfo.padding * 2 )
    canvasInfo.contentHeight = canvas.height - ( canvasInfo.padding * 2 )
    if (chartOptions.gap) {
      canvasInfo.cellWidth = (canvasInfo.contentWidth - (chartOptions.gap * (chartOptions.columns - 1))) / chartOptions.columns
      canvasInfo.cellHeight = (canvasInfo.contentHeight - (chartOptions.gap * (chartOptions.rows - 1))) / chartOptions.rows
      canvasInfo.gap = chartOptions.gap
    } else {
      canvasInfo.cellWidth = (canvasInfo.contentWidth) / chartOptions.columns
      canvasInfo.cellHeight = (canvasInfo.contentHeight) / chartOptions.rows
    }
  }

  function initCustomChart() {
    observer.value = useResizeObserver(() => {
      if (!canvasWrap.value) return
      initCanvas()
      drawChart(canvasInfo, canvasWrap.value.children[0].getContext('2d'))
    })
    if (canvasWrap.value) {
      observer.value?.observe(canvasWrap.value)
    }
  }

  onBeforeUnmount(() => {
    if (canvasWrap.value) {
      observer.value?.unobserve(canvasWrap.value)
    }
  })
// lifecycle
onMounted(async () => {
  try {
    const employeeId = userStore.isAdmin ? '' : userStore.user.employeeId
    const result = await getFCSTSummaryList({
      fs_year: props.fiscalYear,
      employee_id: props.employeeId || employeeId
    })
    fetchedData.value = result.rtn.at(0)
    initCustomChart()
  } catch (err) {
    console.error(err)
  }
})

const INIT_TEXT_DATA = [
  {
    key: 'title',
    value: '',
    coords: {
      x: ['0', 16],
      y: ['1', 16],
    },
    style: {
      textAlign: 'start',
      textBaseline: 'top',
      fillStyle: '#aaaaaa',
      font: `32px suit-m`
    }
  },
  {
    key: 'ratio',
    value: '',
    coords: {
      x: ['0', '2', -16],
      y: ['1', 16],
    },
    style: {
      textAlign: 'end',
      textBaseline: 'top',
      fillStyle: '#aaaaaa',
      font: `32px suit-m`
    }
  },
  {
    key: 'value',
    value: '',
    coords: {
      x: ['0', '2', -16],
      y: ['1', '3', -16],
    },
    style: {
      textAlign: 'end',
      textBaseline: 'bottom',
      fillStyle: '#aaaaaa',
      font: `64px suit-m`
    }
  },
  {
    key: 'unit',
    value: '단위: 억원',
    coords: {
      x: ['0', '2', -16],
      y: ['1', -4],
    },
    style: {
      textAlign: 'end',
      textBaseline: 'bottom',
      fillStyle: '#000000',
      font: `24px suit-m`
    }
  }
]

function drawChart(canvasInfo, ctx) {
  draw(canvasInfo, ctx, [0.3, '#f5f5f5', '#ffffff'], [0, 0, 6, 8], [
    {
      key: 'title',
      value: 'Revenue Forecast'
    },
    {
      key: 'ratio',
      value: `${+fetchedData.value.fccstper}%`

    },
    {
      key: 'value',
      value: `${numberFormatter(fetchedData.value.revenueforcastcurr)}`,
      style: {
        fillStyle: '#003366',
      }
    },
  ])
  draw(canvasInfo, ctx, [0.7, '#fcfefc', '#e9f8e2'], [6, 1, 3, 6], [
    {
      key: 'title',
      value: 'Commit'
    },
    {
      key: 'value',
      value: `${numberFormatter(fetchedData.value.commitvalue)}`,
      style: {
        fillStyle: '#259d00',
      }
    },
  ])
  draw(canvasInfo, ctx, [0.6, '#e6fbfc', '#f8fefe'], [9, 1, 3, 3], [
    {
      key: 'title',
      value: 'Close'
    },
    {
      key: 'value',
      value: `${numberFormatter(fetchedData.value.closevalue)}`,
      style: {
        fillStyle: '#007bba',
      }
    },
    {
      key: 'unit'
    }
  ])
  draw(canvasInfo, ctx, [0.6, '#ecefff', '#fbfcff'], [9, 4, 3, 3], [
    {
      key: 'title',
      value: 'Won'
    },
    {
      key: 'value',
      value: `${numberFormatter(fetchedData.value.wonvalue)}`,
      style: {
        fillStyle: '#5f55e4',
      }
    },
  ])

  draw(canvasInfo, ctx, [0.3, '#f5f5f5', '#ffffff'], [0, 8, 6, 8], [
    {
      key: 'title',
      value: 'Forecast-Risk+Bridge'
    },
    {
      key: 'ratio',
      value: `${+fetchedData.value.fcstriskbridgeper}%`
    },
    {
      key: 'value',
      value: `${numberFormatter(fetchedData.value.revenueforcastriskbridgecurr)}`,
      style: {
        fillStyle: '#003366',
      }
    },
  ])
  draw(canvasInfo, ctx, [0.7, '#fffdfd', '#fdeceb'], [6, 9, 3, 6], [
    {
      key: 'title',
      value: 'Risk'
    },
    {
      key: 'value',
      value: `${numberFormatter(fetchedData.value.riskvalue)}`,
      style: {
        fillStyle: '#ff3548',
      }
    },
  ])
  draw(canvasInfo, ctx, [0.8, '#fffcec', '#fffffc'], [9, 9, 3, 6], [
    {
      key: 'title',
      value: 'Bridge'
    },
    {
      key: 'value',
      value: `${numberFormatter(fetchedData.value.bridgevalue)}`,
      style: {
        fillStyle: '#e2ae03',
      }
    },
    {
      key: 'unit'
    }
  ])
}

function drawBox(ctx, { coords, radius, width, bgColor = 'black' }) {
  const border = new Path2D()
  border.roundRect(...coords, radius + 2)
  if (Array.isArray(bgColor)) {
    const [a, start, end] = bgColor
    const [x, y, w, h] = coords
    const gradient = ctx.createLinearGradient(x, y + (h / 2), x + w, y + (h / 2))
    gradient.addColorStop(0, start);
    gradient.addColorStop(a, end);
    ctx.fillStyle = gradient
  } else {
    ctx.fillStyle = bgColor
  }
  ctx.fill(border)
}

function drawText(ctx, { value, coords, style = {} }) {
  if (Object.keys(style).length) {
    Object.entries(style).forEach(([key, value]) => {
      ctx[key] = value
    })
  }
  ctx.fillText(value, coords.x, coords.y)
}

function draw(canvasInfo, ctx, bgColor, [x, y, w, h], textData) {
  const coords = [
    (canvasInfo.cellWidth + canvasInfo.gap) * x + canvasInfo.padding,
    (canvasInfo.cellHeight + canvasInfo.gap) * y + canvasInfo.padding,
    w * (canvasInfo.cellWidth + canvasInfo.gap) - canvasInfo.gap,
    h * (canvasInfo.cellHeight + canvasInfo.gap) - canvasInfo.gap
  ]
  const radius = 6
  const width = 1

  // border
  drawBox(ctx, { coords, radius, width, bgColor: '#b2c1d1' })

  // background
  const offsetCoords = coords.map((item, index) => {
    if (index > 1) {
      return item - (width * 2)
    }
    return item + width
  })
  drawBox(ctx, { coords: offsetCoords, radius, width, bgColor })

  if (textData) {
    const mappedTextData = INIT_TEXT_DATA
      .filter(initData => {
        const a = textData.filter(item => initData.key === item.key).length
        return a
      })
      .map(initData => {
        const target = textData.find(item => initData.key === item.key)
        const obj = {
          ...initData,
          coords: {
            x: getOffsetCoord(initData.coords.x, offsetCoords),
            y: getOffsetCoord(initData.coords.y, offsetCoords),
          },
          ...target
        }

        if (target.style) {
          obj.style = {
            ...initData.style,
            ...target.style
          }
        }

        if (obj.key === 'title') {
          obj.style.font = `${getFontSize(canvasInfo, props.gridArea, 6)}px suit-m`
        }
        if (obj.key === 'ratio') {
          obj.style.fillStyle = getFontColor(obj.value)
          obj.style.font = `${getFontSize(canvasInfo, props.gridArea, 6)}px suit-m`
        }
        if (obj.key === 'value') {
          if (h === 8) {
            obj.style.font = `bold ${getFontSize(canvasInfo, props.gridArea, 8)}px suit-m`
            obj.coords.y -= coords[3] / 8
          }
          if (h === 6) {
            obj.style.font = `bold ${getFontSize(canvasInfo, props.gridArea, 8)}px suit-m`
          }
          if (h === 3) {
            obj.style.font = `bold ${getFontSize(canvasInfo, props.gridArea, 6)}px suit-m`
          }
        }
        if (obj.key === 'unit') {
          obj.style.font = `${getFontSize(canvasInfo, props.gridArea, 4)}px suit-m`
        }
        return obj
      })
    mappedTextData.forEach(datum => {
      drawText(ctx, datum)
    })
  }
}

function getOffsetCoord(data, offsetCoords) {
  return data.reduce((prev, curr) => {
    if (typeof prev === 'string' && typeof curr === 'string') {
      return offsetCoords[prev] + offsetCoords[curr]
    }
    if (typeof prev === 'string') {
      return offsetCoords[prev] + curr
    }
    if (typeof curr === 'string') {
      return prev + offsetCoords[curr]
    }
    return prev + curr
  })
}

function getFontColor(value) {
  const [convertedValue] = value.split('%')
  const condition = {
    red: +convertedValue < 80,
    orange: 80 <= +convertedValue && +convertedValue < 100,
    green: 100 <= +convertedValue
  }
  const [color] = Object.entries(condition).find(item => item[1])
  return color
}

</script>

<template>
  <article :ref="(element) => canvasWrap = element" :style="{ width: `${width}px`, height: `${height}px` }">
    <canvas id="FCSTSummary"></canvas>
  </article>
</template>

<style scoped>
article {
  display: flex;
  justify-content: center;
  flex: 1 0 auto;
}
</style>